import React from 'react';
import { Box, Card } from '@mui/material';

export default function HoverCard3D({ children, onClick, sx, cardSx }) {
  return (
    <Box sx={{ perspective: '1100px', height: '100%', ...sx }}>
      <Card
        elevation={0}
        onClick={onClick}
        sx={{
          height: '100%',
          transformStyle: 'preserve-3d',
          transition:
            'transform 0.5s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.5s',
          transform: 'rotateX(0deg) rotateY(0deg) translateZ(0)',
          '&:hover': {
            transform: 'rotateX(-3deg) rotateY(4deg) translateZ(10px)',
            boxShadow:
              '0 24px 48px -12px rgba(91, 58, 41, 0.18), 0 0 0 1px rgba(196, 92, 62, 0.12)',
          },
          ...cardSx,
        }}
      >
        {children}
      </Card>
    </Box>
  );
}
